import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

export default class ProdutoChipRequest extends CrudRequest {
  static baseUrl() {
    return 'produto-servico/produto-chip';
  }

  static save(payload) {
    return httpService.post(
      `${this.baseUrl()}/add`,
      payload,
    );
  }

  static list(params = {}) {
    return httpService.get(
      `${this.baseUrl()}/list-all`,
      {
        params,
      },
    );
  }
}
